export default "__VITE_ASSET__N37L6tSx__"